import { pathOr } from 'ramda';
import { IApplicationState } from '../../types/redux';

export const selectCurrentPage = (state: IApplicationState): number => {
  return pathOr(1, ['jsonQuery', 'page', 'value'], state);
};
